import request from './request'

export function listDelivery(data) {
  return request.post('/sales/deliveries/list', data)
}
export function getDelivery(id) {
  return request.get('/sales/deliveries/' + id)
}
export function saveDelivery(data) {
  return request.post('/sales/deliveries', data)
}
export function updateDelivery(data) {
  return request.post('/sales/deliveries/update', data)
}
export function deleteDelivery(ids) {
  return request.post('/sales/deliveries/delete', ids)
}
export function reserveDelivery(id) {
  return request.post('/sales/deliveries/reserve', { deliveryId: id })
}
export function releaseDeliveryReserve(id) {
  return request.post('/sales/deliveries/release-reserve', { deliveryId: id })
}
export function shipDelivery(id) {
  return request.post('/sales/deliveries/ship', { deliveryId: id })
}
export function unshipDelivery(id) {
  return request.post('/sales/deliveries/unship', { deliveryId: id })
}
export function completeDelivery(id) {
  return request.post('/sales/deliveries/complete', { deliveryId: id })
}
